import type { HourlyTagCategory } from "@/pages/human-resources/time-management/business/hourly-tag/HourlyTagCategory.ts";
import type { HourlyTag } from "@/pages/human-resources/time-management/business/hourly-tag/HourlyTag.ts";
import { defined } from "@/shared/utils/makeDefined.ts";

export class HourlyTagCategoryResolver {
  private readonly tagsById: Map<string, HourlyTag>;
  private readonly tagsByCategory: Map<HourlyTagCategory, HourlyTag>;
  constructor(hourlyTags: HourlyTag[]) {
    this.tagsById = new Map<string, HourlyTag>(
      hourlyTags.map((t) => [t.id, t]),
    );
    this.tagsByCategory = new Map<HourlyTagCategory, HourlyTag>(
      hourlyTags.map((t) => [t.category, t]),
    );
  }

  public getById(id: string): HourlyTag {
    return defined(this.tagsById.get(id), `No hourly tag found for id: ${id}`);
  }

  public getByCategory(category: HourlyTagCategory): HourlyTag {
    return defined(
      this.tagsByCategory.get(category),
      `No hourly tag found for category: ${category}`,
    );
  }

  public idToCategory(id: string | undefined): HourlyTagCategory | undefined {
    return id === undefined ? undefined : this.getById(id).category;
  }

  public categoryToId(
    category: HourlyTagCategory | undefined,
  ): string | undefined {
    return category === undefined ? undefined : this.getByCategory(category).id;
  }
}
